import request from '@/utils/request';

export function chat(params) {
    return request({
        method: 'post',
        url: 'index/index',
		data:params
    })
}
export function articleDetail(params) {
    return request({
        method: 'post',
        url: 'article/detail',
		data:params
    })
}
export function createVideo(params) {
    return request({
        method: 'post',
        url: 'article/createVideo',
		data:params
    })
}
export function updateContent(params) {
    return request({
        method: 'post',
        url: 'article/updateContent',
		data:params
    })
}